const getSearchKeywords = (query) =>
	(query || "")
		.toLowerCase()
		.split(/\s+/)
		.filter(Boolean);

const normalizeSearchValue = (value) =>
	value === null || value === undefined ? "" : value.toString().toLowerCase();

export const matchesSearchInValues = (values, query) => {
	const keywords = getSearchKeywords(query);

	if (!keywords.length) return true;

	const normalizedValues = values.map(normalizeSearchValue);

	return keywords.every((keyword) =>
		normalizedValues.some((value) => value.includes(keyword))
	);
};

export const matchesSearchInObject = (item, query) =>
	matchesSearchInValues(Object.values(item || {}), query);

export const searchByKeywords = (items, query, keys) => {
	if (!query || !query.trim()) return items;

	return items.filter((item) =>
		matchesSearchInValues(
			keys.map((key) => item[key]),
			query
		)
	);
};
